import Vue from 'vue/dist/vue.js';
import retailerMap from './vueComponents/retailerMap.js';
import allRetailersMap from './vueComponents/allRetailersMap.js';

export default {
    name: 'productContact',
    _el: null,
    _maps: null,

    init() {
        this._el = document.getElementById('js_retailerMap');
        if (document.getElementById('js_retailerMap')) {
            this.run();
        }
    },

    run ()
    {
        let retailers = JSON.parse(this._el.dataset.json);

        new Vue({
            el : '#js_retailerMap',

            delimiters: ['@{', '}'],

            data:  {
                maps: this.maps,
                items : retailers,
                currentRetailer : retailers[0],
                center : null,
                map : null,
                mapOptions : null,
            },

            created()
            {},
        });
    }
}